import { defineComponent as _defineComponent } from 'vue'
import BaseDialog from "@/components/base-dialog.vue";
import LockCode from "@/assets/icons/svg/lock-code.icon.svg";
import OtpInput from "@/components/otp-input.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'enter-lecture-auth-code-dialog',
  props: {
    isVisible: { type: Boolean },
    onClose: null,
    closeOnCodeEntered: { type: Boolean }
  },
  emits: {
  "on-code-entered": (code: string) => code,
},
  setup(__props: any, { emit }) {

const props = __props as {
  isVisible: boolean;
  onClose: () => void;
  closeOnCodeEntered?: boolean;
}





const closeDialog = () => {
  props.onClose();
};

const onContinue = (value: string) => {
  emit("on-code-entered", value);

  if (props.closeOnCodeEntered ?? true) {
    closeDialog();
  }
};

const handleComplete = (value: string) => {
  onContinue(value);
};

return { __sfc: true,props, emit, closeDialog, onContinue, handleComplete, BaseDialog, LockCode, OtpInput }
}

})